/* RapidCare - wholesale portal gate.
   Ported from the prototype. Access code + unlock state in sessionStorage.
   NOTE: this is a light front-end gate for confidential pricing display, not
   real security. For true protection, gate the page behind Shopify customer
   accounts / B2B or a password-protected page. Code is set via section setting. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rc-wholesale]');
  if (!root) return;

  var KEY = 'rc-wholesale-unlocked';
  var code = (root.getAttribute('data-code') || 'RAPID2026').toUpperCase();
  var gate = root.querySelector('[data-gate]');
  var portal = root.querySelector('[data-portal]');
  var err = root.querySelector('[data-gate-err]');
  var form = root.querySelector('[data-gate-form]');
  var input = root.querySelector('[data-gate-pw]');

  function setUnlocked(on) {
    if (gate) gate.style.display = on ? 'none' : 'flex';
    if (portal) portal.classList.toggle('unlocked', on);
  }

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (input && input.value.trim().toUpperCase() === code) {
      sessionStorage.setItem(KEY, '1');
      setUnlocked(true);
    } else if (err) {
      err.classList.add('show');
    }
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-logout]')) {
      sessionStorage.removeItem(KEY);
      setUnlocked(false);
    }
  });

  setUnlocked(sessionStorage.getItem(KEY) === '1');
})();
